import styled from 'styled-components';
import { Spin } from 'antd';

export const SuspenseSpin = styled(Spin).attrs({ size: 'large' })`
  display: block;
  padding-top: 64px;
  padding-bottom: 64px;
`;
